import axiosInstance from "../api/axiosInstance";

export const fetchTopicContent = (topicType, topicId) =>
  axiosInstance
    .get("/client/topic-content", { params: { topicType, topicId } })
    .then((r) => ({ status: r.status, data: r.data }))
    .catch((e) => ({ status: e.response?.status || 500, data: [], message: e.response?.data?.message || "Failed to load content" }));

export const fetchContentBlockById = (id) =>
  axiosInstance
    .get(`/client/content-blocks/${id}`)
    .then((r) => ({ status: r.status, data: r.data }))
    .catch((e) => ({ status: e.response?.status || 500, message: e.response?.data?.message || "Failed to load content block" }));

export const submitQuiz = (payload) =>
  axiosInstance
    .post("/client/quizzes/submit", payload)
    .then((r) => ({ status: r.status, data: r.data }))
    .catch((e) => ({ status: e.response?.status || 500, message: e.response?.data?.message || "Submit failed" }));

export const fetchQuizAttempts = (quizId) =>
  axiosInstance
    .get(`/client/quizzes/${quizId}/attempts`)
    .then((r) => ({ status: r.status, data: r.data }))
    .catch((e) => ({ status: e.response?.status || 500, data: [], message: e.response?.data?.message || "Failed to load attempts" }));
